import React from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "features/records/components/AttributesForm"

const NewFieldButton = props => (
    <ButtonModal
        button={props.button}
        header={() => `New Stack`}
        footerClassName={css`
            justify-content: flex-end;
        `}
        footer={({ close, state }) => [
            <Button
                key="create"
                sideMargin="xsmall"
                color="success"
                onClick={() => {
                    props.onSave(state)
                    close()
                }}
            >
                Create
            </Button>,
            <Button key="cancel" sideMargin="xsmall" onClick={close}>
                Cancel
            </Button>,
        ]}
    >
        {({ setState }) => (
            <AttributesForm
                onChange={setState}
                fields={[
                    { type: "text", label: "Name", api_name: "name" },
                    // {
                    //     type: "text",
                    //     label: "Base url (optional)",
                    //     api_name: "base_url",
                    // },
                ]}
            />
        )}
    </ButtonModal>
)
export default NewFieldButton



// WEBPACK FOOTER //
// ./src/features/studio/components/NewStackButton.js